/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type SyncConnectionRequest = {
  connectionId: string;
};

/** @internal */
export const SyncConnectionRequest$inboundSchema: z.ZodType<
  SyncConnectionRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  connection_id: z.string(),
}).transform((v) => {
  return remap$(v, {
    "connection_id": "connectionId",
  });
});
/** @internal */
export type SyncConnectionRequest$Outbound = {
  connection_id: string;
};

/** @internal */
export const SyncConnectionRequest$outboundSchema: z.ZodType<
  SyncConnectionRequest$Outbound,
  z.ZodTypeDef,
  SyncConnectionRequest
> = z.object({
  connectionId: z.string(),
}).transform((v) => {
  return remap$(v, {
    connectionId: "connection_id",
  });
});

export function syncConnectionRequestToJSON(
  syncConnectionRequest: SyncConnectionRequest,
): string {
  return JSON.stringify(
    SyncConnectionRequest$outboundSchema.parse(syncConnectionRequest),
  );
}
export function syncConnectionRequestFromJSON(
  jsonString: string,
): SafeParseResult<SyncConnectionRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SyncConnectionRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SyncConnectionRequest' from JSON`,
  );
}
